export default "__VITE_ASSET__a2efadf6__"